import React from "react"
import { Html } from "@react-three/drei"
import { Text } from "../Text"
import Plane from "../Plane"
import { Block, useBlock } from "../../blocks"
import useContentStore from "../../redux/stores/contentStore"

export default function Paragraph({ image, index, offset, factor, left, header, aspect, text, video }) {
  const content = useContentStore((state) => state.content)
  const { contentMaxWidth: w, canvasWidth, margin, mobile } = useBlock()
  const size = aspect < 1 && !mobile ? 0.65 : 1
  const alignRight = (canvasWidth - w * size - margin) / 2
  const pixelWidth = w * content.zoom * size
  // const left = !(index % 2)
  const color = content.colors.header;

  return (
    <Block factor={factor} offset={offset}>
      <group position={[left ? -alignRight : alignRight, 0, 0]}>
        <Plane map={image} video={video} args={[1, 1, 32, 32]} shift={75} size={size} aspect={aspect} scale={[w * size, (w * size) / aspect, 1]} frustumCulled={false} />
        <Html
          style={{ width: pixelWidth / (mobile ? 1 : 2), textAlign: left ? "left" : "right" }}
          position={[left || mobile ? (-w * size) / 2 : 0, (-w * size) / 2 / aspect - 0.4, 1]}>
          <div tabIndex={index}>{text}</div>
        </Html>
        <Text left={left} right={!left} size={w * 0.05} color={color} top position={[((left ? -w : w) * size) / 2, (w * size) / aspect / 2 + 0.5, -1]}>
          {header}
        </Text>
        <Block factor={0.6}>
          <Text opacity={0.5} size={w * 0.075} color="#1A1E2A" position={[((left ? w : -w) / 2) * size, (w * size) / aspect / 1, -10]}>
            UX/UI FRONT
          </Text>
        </Block>
      </group>
    </Block>
  )
}
